/**
 * Custom hook for managing Contact page data
 * Fetches contact information from API
 */

import { useState, useEffect } from 'react';
import { contactGlobalApi } from '@/api';
import { ContactGlobal } from '@/types/contactType';

export interface ContactPageData {
  headerTitle: string;
  headerSubtitle: string;
  headerBackgroundImage: string;
  contactInfo: ContactGlobal | null;
  loading: boolean;
  error: string | null;
}

export const useContactPageData = (): ContactPageData => {
  const [contactInfo, setContactInfo] = useState<ContactGlobal | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await contactGlobalApi.get();
        if (response.success && response.data) {
          setContactInfo(response.data);
        } else {
          setError('Không thể tải thông tin liên hệ');
        }
      } catch (err) {
        console.error('Error fetching contact data:', err);
        setError('Có lỗi xảy ra khi tải dữ liệu');
      } finally {
        setLoading(false);
      }
    };

    fetchContactData();
  }, []);

  return {
    headerTitle: "Liên hệ",
    headerSubtitle: "Kết nối cùng Kiến Tạo Xanh Group",
    headerBackgroundImage: "/header_90ad.png",
    contactInfo,
    loading,
    error,
  };
};